import { BURGERMENU } from "./types"

export function burgerMenu() {
  return {
    type: BURGERMENU
  }
} 